import { createSharedComposable } from '@vueuse/core';

// eslint-disable-next-line regex/invalid
import { AuthModal, RequestPasswordResetModal, SessionExpiredModal } from '#components';
import type { AuthModalProps } from '~/components/Auth/AuthModal.vue';

type UseModalsReturn = {
    openAuthModal: (props?: AuthModalProps) => Promise<boolean>;
    closeAuthModal: () => void;

    openRequestPasswordResetModal: (props?: { email: string }) => void;
    closeRequestPasswordResetModal: () => void;

    openSessionExpiredModal: () => void;
    closeSessionExpiredModal: () => void;
};

export const _useModals = (): UseModalsReturn => {
    const overlay = useOverlay();
    const { isLoggedIn } = useAuthUtils();

    // MODALS
    const authModal = overlay.create(AuthModal);
    const requestPasswordResetModal = overlay.create(RequestPasswordResetModal);
    const sessionExpiredModal = overlay.create(SessionExpiredModal);

    return {
        openAuthModal: props =>
            authModal.isOpen
                ? Promise.resolve(false)
                : authModal.open(
                      props ?? {
                          email: undefined,
                          action: undefined,
                      }
                  ),
        closeAuthModal: () => authModal.close(),

        openRequestPasswordResetModal: props => !isLoggedIn.value && requestPasswordResetModal.open(props),
        closeRequestPasswordResetModal: () => requestPasswordResetModal.close(),

        openSessionExpiredModal: () => sessionExpiredModal.open(),
        closeSessionExpiredModal: () => sessionExpiredModal.close(),
    };
};

export const useModals = createSharedComposable(_useModals);
